module.exports = "<ion-tabs #myTabs (ionTabsDidChange)=\"tabChanged()\">\n\n</ion-tabs>"